import { FloorPlanItemType } from '../enums';
import { ObjectAttributes, SectionAttributes, TableAttributes } from './floor-plan-attributes';
import { Shapes } from '../../core';
import { TableSizes } from '../../floor-plans';

export type FloorPlanItem = {
  id: string;
  floorPlanId: string;
  type: FloorPlanItemType.table;
  name: string;
  attributes: TableAttributes;
} | {
  id: string;
  floorPlanId: string;
  type: FloorPlanItemType.object;
  name: string;
  attributes: ObjectAttributes;
} | {
  id: string;
  floorPlanId: string;
  type: FloorPlanItemType.section;
  name: string;
  attributes: SectionAttributes;
}

export abstract class FloorPlanBaseItem {
  id: string;
  floorPlanId: string;
  name: string;

  constructor(id: string, floorPlanId: string, name: string) {
    this.id = id;
    this.floorPlanId = floorPlanId;
    this.name = name;
  }

  abstract getAttributes();
}

export class FloorPlanObject extends FloorPlanBaseItem {
  readonly type = FloorPlanItemType.object;
  size: TableSizes;
  width: number;
  height: number;
  top: number;
  left: number;
  shape: Shapes;
  rotation?: number;

  constructor(id: string, floorPlanId: string, name: string, attributes: ObjectAttributes) {
    super(id, floorPlanId, name);
    this.size = attributes.size;
    this.width = attributes.width;
    this.height = attributes.height;
    this.top = attributes.top;
    this.left = attributes.left;
    this.shape = attributes.shape;
    this.rotation = attributes.rotation;
  }

  getAttributes(): ObjectAttributes {
    return {
      size: this.size,
      width: this.width,
      height: this.height,
      top: this.top,
      left: this.left,
      shape: this.shape,
      rotation: this.rotation,
    };
  }
}

export class FloorPlanSection extends FloorPlanBaseItem {
  readonly type = FloorPlanItemType.section;
  color: string;
  tableIds: string[];

  constructor(id: string, floorPlanId: string, name: string, attributes: SectionAttributes) {
    super(id, floorPlanId, name);
    this.color = attributes.color;
    this.tableIds = attributes.tableIds;
  }

  getAttributes(): SectionAttributes {
    return {
      color: this.color,
      tableIds: this.tableIds,
    };
  }
}

export interface GroupedItems {
  tables: FloorPlanTable[];
  objects: FloorPlanObject[];
  sections: FloorPlanSection[];
}

export class FloorPlanTable extends FloorPlanBaseItem {
  readonly type = FloorPlanItemType.table;
  size: TableSizes;
  width: number;
  height: number;
  top: number;
  left: number;
  shape: Shapes;
  rotation?: number;
  resourceId?: string;

  constructor(id: string, floorPlanId: string, name: string, attributes: TableAttributes) {
    super(id, floorPlanId, name);
    this.size = attributes.size;
    this.width = attributes.width;
    this.height = attributes.height;
    this.top = attributes.top;
    this.left = attributes.left;
    this.shape = attributes.shape;
    this.rotation = attributes.rotation;
    this.resourceId = attributes.resourceId;
  }

  getAttributes(): TableAttributes {
    return {
      size: this.size,
      width: this.width,
      height: this.height,
      top: this.top,
      left: this.left,
      shape: this.shape,
      rotation: this.rotation,
      resourceId: this.resourceId,
    };
  }
}
